export default __webpack_public_path__ + "static/media/saved.ef49b3b3.svg";